// src/features/auth/utils/workspaceRoleStatus.ts
import type { WorkspaceRole, WorkspaceStatus } from '../types';

/**
 * role/status は今後テキストで管理する。
 * ただし移行期間のフォールバックとして、旧データ(数値)も読み取り時だけ吸収する。
 *
 * role:
 * - owner (旧: 1)
 * - member (旧: 2)
 *
 * status:
 * - active (旧: 1)
 * - inactive (旧: 0)
 */
export function normalizeWorkspaceRole(input: unknown): WorkspaceRole {
  if (input === 'owner') return 'owner';
  if (input === 'admin') return 'admin';
  if (input === 'member') return 'member';
  // 旧データフォールバック
  // 1: 管理者, 2: メンバー
  if (input === 1) return 'admin';
  if (input === 2) return 'member';
  return 'member';
}

export function normalizeWorkspaceStatus(input: unknown): WorkspaceStatus {
  if (input === 'active') return 'active';
  if (input === 'inactive') return 'inactive';
  if (input === 1) return 'active';
  if (input === 0) return 'inactive';
  return 'active';
}

export function workspaceRoleWeight(role: WorkspaceRole): number {
  switch (role) {
    case 'owner':
      return 3;
    case 'admin':
      return 2;
    default:
      return 1;
  }
}

